"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function formatIn(value) {
  var result = value;
  try {
    result = JSON.parse(value);
  } catch (e) {}
  return result;
}

function formatOut(value) {
  var result = value;
  try {
    result = JSON.stringify(value);
  } catch (e) {}
  return result;
}

exports.default = {
  formatIn: formatIn,
  formatOut: formatOut
};
module.exports = exports["default"];